import { render, staticRenderFns } from "./activity-form-vas-preview.vue?vue&type=template&id=90b670ce&scoped=true&"
import script from "./activity-form-vas-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-vas-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-vas-preview.vue?vue&type=style&index=0&id=90b670ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b670ce",
  null
  
)

component.options.__file = "activity-form-vas-preview.vue"
export default component.exports